import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HasRoleDirective } from './has-role.directive';
import { MatTabScrollToCenterDirective } from './scroll-to-center.directive';

@NgModule({
  declarations: [HasRoleDirective, MatTabScrollToCenterDirective],
  exports: [HasRoleDirective, MatTabScrollToCenterDirective],
  imports: [
    CommonModule
  ]
})
export class SharedDirectivesModule { }
